/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Select_Folder_ButtonInputs */



/**
* | output |
* | --- |
* | "Select Folder" |
*
* @param {Audio_Description_Export_Select_Folder_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_select_folder_button = /** @type {((inputs?: Audio_Description_Export_Select_Folder_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Select_Folder_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisir un dossier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ordner auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona cartella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите папку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar carpeta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォルダを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ोल्डर चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecionar pasta")
	return /** @type {LocalizedString} */ ("Select Folder")
});